module.exports = "<section class=\"selectShipping\">\n    <xo-select-shipping done-fn=\"onComplete\" token=\"token\"></xo-select-shipping>\n</section>\n"


/*****************
 ** WEBPACK FOOTER
 ** ./pages/xo-shipping/template.html
 ** module id = 317
 ** module chunks = 1
 **/